import React, { useState, useCallback } from 'react'
import { Box, TextField, CircularProgress } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { RequestIdDisplay } from '../../../components/organisms/RequestIdDisplay'
import { Prescription } from '../../../types/models/Presc'
import { getPrescriptionByRequestId } from '../apis/prescription'

export const useAnnotate = (): {
  selectedPresc: Prescription | null
  SearchBox: JSX.Element
} => {
  const [selectedPresc, setSelectedPresc] = useState<Prescription | null>(null)
  const [searchText, setSearchText] = useState('')
  const [isSearching, setIsSearching] = useState(false)
  const [searchError, setSearchError] = useState('')

  const handleDirectSearch = useCallback(async (requestId: string) => {
    const trimmed = requestId.trim()
    if (!trimmed) return

    setIsSearching(true)
    setSearchError('')
    try {
      const response = await getPrescriptionByRequestId(trimmed)
      setSelectedPresc(response.data)
      setSearchText('')
    } catch {
      setSearchError('該当する処方箋が見つかりません')
      setSelectedPresc(null)
    } finally {
      setIsSearching(false)
    }
  }, [])

  const SearchBox = (
    <Box
      sx={{
        p: 2,
        width: '100%',
        backgroundColor: 'background.paper',
        borderRadius: 1,
        mb: 1,
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ mb: 0.5, fontSize: '0.875rem', color: 'text.secondary' }}>
        リクエストID検索
      </Box>
      <TextField
        fullWidth
        variant="outlined"
        placeholder="リクエストIDを貼り付けてEnter"
        value={searchText}
        onChange={(e) => {
          setSearchText(e.target.value)
          setSearchError('')
        }}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            handleDirectSearch(searchText)
          }
        }}
        InputProps={{
          startAdornment: isSearching ? (
            <CircularProgress size={20} sx={{ mr: 1 }} />
          ) : (
            <SearchIcon sx={{ mr: 1, color: 'action.active' }} />
          ),
        }}
        error={!!searchError}
        helperText={searchError}
        sx={{ backgroundColor: 'white' }}
      />
      <RequestIdDisplay requestId={selectedPresc?.ocr_request_event_id} />
    </Box>
  )

  return {
    selectedPresc,
    SearchBox,
  }
}
